module.exports = {
      id: "logic-usage",
      viewBox: "0 0 19.765 19.765",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#logic",
      toString: function () {
        return this.url;
      }
    }